<template>
  <div class="contact-form-area pt-100 pb-70">
    <div class="container">
      <div class="row pt-45">
        <div class="col-lg-4"></div>
        <div class="col-lg-8">
          <div class="section-title text-right">
            <h3>Please share your queries completing the form below. We will reply to you shortly.</h3>
          </div>
        </div>
      </div>

      <div class="row pt-45">
        <div class="col-lg-4">
          <div class="contact-info mr-20">
            <span>Contact Info</span>
            <h2>Let's Connect With Us</h2>
            <!--<p>
              To discuss how we can help you, please reach out to us. We are always up for a conversation.
            </p>-->
            <ul>
              <li>
                <div class="content">
                  <i class="bx bx-phone-call"></i>
                  <h3>Phone Number</h3>
                  <a href="tel:+1(214)-431-5175">+1 (214) 431-5175</a>
                </div>
              </li>
              <li>
                <div class="content">
                  <i class="bx bxs-map"></i>
                  <h3>USA - Texas</h3>
                  <span>539 W. Commerce St #8077 Dallas, TX-75208</span>
                </div>
              </li>
              <li>
                <div class="content">
                  <i class="bx bx-phone-call"></i>
                  <h3>Phone Number</h3>
                  <a href="tel:+91 7709138516">+91 77091 38516</a>
                </div>
              </li>
              <li>
                <div class="content">
                  <i class="bx bxs-map"></i>
                  <h3>India - Pune</h3>
                  <span>RH-4, Kanchanpushpa, Shelarmala, Katraj, Pune 411046</span>
                </div>
              </li>
              <li>
                <div class="content">
                  <i class="bx bx-message"></i>
                  <h3>Contact Info</h3>
                  <a href="mailto:info@lucreskilltech.com">info@lucreskilltech.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="contact-form">
            <form id="contactForm">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Your Name <span>*</span></label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      class="form-control"
                      required
                      placeholder="Name"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Your Email <span>*</span></label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      class="form-control"
                      required
                      placeholder="Email"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Phone Number <span>*</span></label>
                    <input
                      type="text"
                      name="phone_number"
                      id="phone_number"
                      required
                      class="form-control"
                      placeholder="Phone Number"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Your Subject <span>*</span></label>
                    <input
                      type="text"
                      name="msg_subject"
                      id="msg_subject"
                      class="form-control"
                      required
                      placeholder="Your Subject"
                    />
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="form-group">
                    <label>Your Message <span>*</span></label>
                    <textarea
                      name="message"
                      class="form-control"
                      id="message"
                      cols="30"
                      rows="8"
                      required
                      placeholder="Your Message"
                    ></textarea>
                    <div class="help-block with-errors"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="agree-label">
                    <input type="checkbox" id="chb1" />
                    <label for="chb1">
                      Accept
                      <router-link to="/terms-condition"
                        >Terms & Conditions</router-link
                      >
                      And
                      <router-link to="/privacy-policy"
                        >Privacy Policy.</router-link
                      >
                    </label>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 text-center">
                  <button
                    type="submit"
                    class="default-btn btn-bg-two border-radius-50"
                  >
                    Send Message <i class="bx bx-chevron-right"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
};
</script>